<template>
  <validation-provider #default="validationContext" :name="label" :rules="rules">
    <b-form-group
      :label="label"
      :label-for="id"
      :description="description"
      :state="getValidationState(validationContext)"
    >
      <b-input-group
        v-if="type === 'password'"
        class="input-group-merge"
        :class="getValidationState(validationContext) === false ? 'is-invalid' : ''"
      >
        <b-form-input
          :id="id"
          v-model="inputValue"
          :placeholder="placeholder"
          :state="getValidationState(validationContext)"
          :type="passwordFieldType"
          trim
        />
        <b-input-group-append is-text>
          <feather-icon
            class="cursor-pointer"
            :icon="passwordToggleIcon"
            @click="togglePasswordVisibility"
          />
        </b-input-group-append>
      </b-input-group>

      <b-form-input
        v-else
        :id="id"
        v-model="inputValue"
        :placeholder="placeholder"
        :state="getValidationState(validationContext)"
        :type="type"
        trim
      />
      <b-form-invalid-feedback :state="getValidationState(validationContext)">
        {{ validationContext.errors[0] }}
      </b-form-invalid-feedback>
      <small v-if="hint">{{ hint }}</small>
    </b-form-group>
  </validation-provider>
</template>

<script>
import { ref, watch, computed } from "@vue/composition-api";
import formValidation from "@core/comp-functions/forms/form-validation";
import { ValidationObserver, ValidationProvider } from "vee-validate";

export default {
  name: "FormFieldText",
  components: {
    ValidationObserver,
    ValidationProvider,
  },
  props: {
    value: {
      type: [String, Number],
      required: false,
      default: "",
    },
    id: {
      type: String,
      required: true,
    },
    label: {
      type: String,
      required: true,
    },
    rules: {
      type: String,
      default: "",
    },
    placeholder: {
      type: String,
      default: "",
    },
    description: {
      type: String,
      default: "",
    },
    type: {
      type: String,
      default: "text",
    },
    hint: {
      type: String,
      default: "",
    }
  },
  setup(props, { emit }) {
    const { getValidationState } = formValidation();
    const inputValue = ref(props.value === null || props.value === undefined ? "" : props.value);

    const passwordFieldType = ref("password");
    const passwordToggleIcon = computed(() => {
      return passwordFieldType.value === "password" ? "EyeIcon" : "EyeOffIcon";
    });
    const togglePasswordVisibility = () => {
      passwordFieldType.value = passwordFieldType.value === "password" ? "text" : "password";
    };

    watch(
      () => props.value,
      (newValue) => {
        inputValue.value = newValue === null || newValue === undefined ? "" : newValue;
      }
    );

    watch(
      () => inputValue.value,
      (newValue) => {
        emit("input", newValue);
      }
    );

    return {
      inputValue,
      getValidationState,
      passwordFieldType,
      passwordToggleIcon,
      togglePasswordVisibility,
    };
  },
};
</script>
